__webpack_require__.b = document.baseURI || self.location.href;

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	2827: 0,
	79: 0,
	6696: 0,
	5210: 0,
	688: 0,
	5142: 0,
	1381: 0,
	2114: 0,
	5366: 0,
	9918: 0,
	2472: 0,
	6595: 0
};

// no chunk on demand loading

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

// no on chunks loaded

// no jsonp function